/*
 * @Descripttion: 库存管理
 * @Author: 曹博
 * @Date: 2023-10-17 17:03:54
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-24 10:10:07
 */

import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tooltip,
  TreeSelect,
} from 'antd'
import Search from '../../components/SearchFilter'
import styles from './inventoryManagement.module.scss'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import UseInventoryManagementHook from './hooks'
import { ProductSellAreaDTO } from './reducer'
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import Uploadfiles from '../../modules/uploadfiles'

const InventoryManagement = () => {
  const {
    hookstate,
    form,
    platform,
    handleSearchClick,
    onRefresh,
    exportData,
    handlePaginationChange,
    openReviseModal,
    closeReviseModal,
    cofirmReviseInventory,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    changeImportModalVisible,
    getOriginFile,
    onSwitchChange,
  } = UseInventoryManagementHook()
  const {
    dataSource,
    pages,
    loading,
    isReviseModalVisible,
    reviseModalConfirmBtnLoading,
    currentReviseMaterial,
    isImportModalVisible,
    isImportModalConfirmBtnLoading,
    uploadFilesList,
    projectOptions,
    areaDataOptions,
    editLoading,
  } = hookstate

  // 同物料编码的数据第二行开始不展示前四列
  const filterDescription = (
    text: string,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return index === 0 ? (
      <span>{text}</span>
    ) : dataSource.data[index - 1]?.['code'] === record.code ? (
      ''
    ) : (
      <span>{text}</span>
    )
  }

  // 可售区域渲染函数
  const sellAreaRender = (
    text: string,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return record.allAreaList[index]?.sysRegionCodeName ? (
      <span>{record.allAreaList[index]?.sysRegionCodeName}</span>
    ) : (
      <span style={{ color: '#F5222D' }}>待填写</span>
    )
  }

  // 区域库存渲染函数
  const stockRender = (
    text: number,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return record.allAreaList[index]?.inventoryAmount ? (
      <span>
        {Math.round(Number(record.allAreaList[index]?.inventoryAmount))}
      </span>
    ) : (
      <span style={{ color: '#F5222D' }}>待填写</span>
    )
  }

  const switchRender = (record: ProductSellAreaDTO, index: number) => {
    return record.allAreaList[index]?.inventoryStatus ? (
      <Switch
        checked={record.allAreaList[index]?.inventoryStatus === '1'}
        onChange={(checked) => onSwitchChange(checked, record, index)}
      />
    ) : (
      '-'
    )
  }

  const columns = [
    {
      key: 'code',
      title: '物料编码',
      dataIndex: 'code',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'name',
      title: '物料名称',
      dataIndex: 'name',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'manuCode',
      title: '规格型号',
      dataIndex: 'manuCode',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'unitName',
      title: '单位',
      dataIndex: 'unitName',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'sellArea',
      title: '库存所在地',
      dataIndex: 'sellArea',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        sellAreaRender(text, record, index),
    },
    {
      key: 'stock',
      title: '区域库存',
      dataIndex: 'stock',
      render: (text: number, record: ProductSellAreaDTO, index: number) =>
        stockRender(text, record, index),
    },
    {
      key: 'state',
      title: '库存状态',
      dataIndex: 'state',
      render: (text: number, record: ProductSellAreaDTO, index: number) =>
        switchRender(record, index),
    },
    {
      key: 'operate',
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: ProductSellAreaDTO, index: number) => {
        return index === 0 ||
          dataSource.data[index - 1].code !== record.code ? (
          <a onClick={() => openReviseModal(record)}>编辑</a>
        ) : (
          ''
        )
      },
    },
  ]

  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['productCode', 'proName', 'model']}
        onSearch={handleSearchClick}
        keyName="INVENTORYMANAGEMENT"
        ScreenKey="INVENTORYMANAGEMENT"
      />
      <Row
        justify="space-between"
        align="middle"
        className={styles['info-row']}
      >
        <Space>
          <Buttonbar onRefresh={onRefresh}></Buttonbar>
          <Form
            form={platform}
            style={{ marginLeft: '-120px', height: '24px', lineHeight: '24px' }}
          >
            <Form.Item label="当前项目：" name={'project'}>
              <Select
                style={{ width: 150 }}
                options={projectOptions}
                onChange={() => handleSearchClick({})}
              />
            </Form.Item>
          </Form>
        </Space>
        <Space>
          <Tooltip
            title={
              <>
                <div>
                  1.
                  如果物料只存在指定区域售卖，在设置区域库存的同时，全国仓库存必须设为：0（即：关闭全国仓库存），全国仓地址编码为：-9999；
                </div>
                <div>2. 区域库存和全国仓库存必须分两行导入；</div>
                <div>
                  3.
                  区域库存和全国库存也可同时存在，可按需设置，如：北京设：10；全国设：200
                </div>
              </>
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>

          <span>库存管理规则</span>
          <Button onClick={exportData}>导出全部</Button>
          <Button type="primary" onClick={() => changeImportModalVisible(true)}>
            导入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
      {/* 修改库存弹框 */}
      <Modal
        title="修改库存"
        open={isReviseModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={600}
        style={{ top: '25%' }}
        footer={[
          <Button
            key="closeRejectModal"
            disabled={reviseModalConfirmBtnLoading}
            onClick={closeReviseModal}
          >
            取消
          </Button>,
          <Button
            key="confirmRejectModal"
            type="primary"
            loading={reviseModalConfirmBtnLoading}
            onClick={cofirmReviseInventory}
          >
            提交
          </Button>,
        ]}
      >
        <Spin tip="Loading..." spinning={editLoading}>
          <div>
            <div
              style={{
                marginTop: '-12px',
                marginBottom: '12px',
              }}
            >
              <Row>
                <Col span={12}>物料编码：{currentReviseMaterial.code}</Col>
                <Col span={12}>物料名称：{currentReviseMaterial.name}</Col>
              </Row>
              <Row>
                <Col span={12}>规格型号：{currentReviseMaterial.manuCode}</Col>
                <Col span={12}>单位：{currentReviseMaterial.unitName}</Col>
              </Row>
            </div>
            <div
              style={{
                overflow: 'auto',
                minHeight: '400px',
                maxHeight: '550px',
              }}
            >
              <Form form={form}>
                <Form.List name="list">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space
                          key={key}
                          style={{ display: 'flex' }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            label="可售区域"
                            name={[name, 'sellArea']}
                            rules={[
                              { required: true, message: '请选择可售区域' },
                            ]}
                          >
                            <TreeSelect
                              showSearch
                              treeNodeFilterProp="title"
                              dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                              }}
                              placeholder="请选择"
                              allowClear
                              multiple
                              treeDefaultExpandAll
                              treeData={areaDataOptions}
                              style={{ width: '200px' }}
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label="区域库存"
                            name={[name, 'stock']}
                            rules={[
                              { required: true, message: '请输入区域库存' },
                            ]}
                          >
                            <InputNumber
                              precision={0}
                              min={-99999}
                              max={999999999}
                              style={{ width: '120px' }}
                            />
                          </Form.Item>
                          <Form.Item {...restField} name={[name, 'isNewItem']}>
                            {!form.getFieldsValue().list[index]?.isNewItem ? (
                              <MinusCircleOutlined
                                style={{ margin: '0 12px' }}
                                onClick={() => remove(name)}
                              />
                            ) : (
                              ''
                            )}
                          </Form.Item>
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusCircleOutlined />}
                        >
                          添加库存所在地及库存
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
      {/* 导入区域库存弹框 */}
      <Modal
        title="导入区域库存"
        open={isImportModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={'30%'}
        style={{ top: '25%' }}
        okText="提交"
        cancelButtonProps={{
          disabled: isImportModalConfirmBtnLoading,
          onClick: () => changeImportModalVisible(false),
        }}
        okButtonProps={{
          type: 'primary',
          loading: isImportModalConfirmBtnLoading,
          onClick: cofirmImportModal,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={downloadTemplate}>
            下载导入模板 <DownloadOutlined />
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title="选择文件"
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            getOriginFile={getOriginFile}
            accept=".xls,.xlsx"
            maxCount={1}
            directlyDelete
            type = "regionalStock"
          />
          {!uploadFilesList.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default InventoryManagement
/*
 * @Descripttion: 库存管理
 * @Author: 曹博
 * @Date: 2023-10-17 17:03:54
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-24 10:10:07
 */

import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tooltip,
  TreeSelect,
} from 'antd'
import Search from '../../components/SearchFilter'
import styles from './inventoryManagement.module.scss'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import UseInventoryManagementHook from './hooks'
import { ProductSellAreaDTO } from './reducer'
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import Uploadfiles from '../../modules/uploadfiles'

const InventoryManagement = () => {
  const {
    hookstate,
    form,
    platform,
    handleSearchClick,
    onRefresh,
    exportData,
    handlePaginationChange,
    openReviseModal,
    closeReviseModal,
    cofirmReviseInventory,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    changeImportModalVisible,
    getOriginFile,
    onSwitchChange,
  } = UseInventoryManagementHook()
  const {
    dataSource,
    pages,
    loading,
    isReviseModalVisible,
    reviseModalConfirmBtnLoading,
    currentReviseMaterial,
    isImportModalVisible,
    isImportModalConfirmBtnLoading,
    uploadFilesList,
    projectOptions,
    areaDataOptions,
    editLoading,
  } = hookstate

  // 同物料编码的数据第二行开始不展示前四列
  const filterDescription = (
    text: string,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return index === 0 ? (
      <span>{text}</span>
    ) : dataSource.data[index - 1]?.['code'] === record.code ? (
      ''
    ) : (
      <span>{text}</span>
    )
  }

  // 可售区域渲染函数
  const sellAreaRender = (
    text: string,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return record.allAreaList[index]?.sysRegionCodeName ? (
      <span>{record.allAreaList[index]?.sysRegionCodeName}</span>
    ) : (
      <span style={{ color: '#F5222D' }}>待填写</span>
    )
  }

  // 区域库存渲染函数
  const stockRender = (
    text: number,
    record: ProductSellAreaDTO,
    index: number,
  ) => {
    return record.allAreaList[index]?.inventoryAmount ? (
      <span>
        {Math.round(Number(record.allAreaList[index]?.inventoryAmount))}
      </span>
    ) : (
      <span style={{ color: '#F5222D' }}>待填写</span>
    )
  }

  const switchRender = (record: ProductSellAreaDTO, index: number) => {
    return record.allAreaList[index]?.inventoryStatus ? (
      <Switch
        checked={record.allAreaList[index]?.inventoryStatus === '1'}
        onChange={(checked) => onSwitchChange(checked, record, index)}
      />
    ) : (
      '-'
    )
  }

  const columns = [
    {
      key: 'code',
      title: '物料编码',
      dataIndex: 'code',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'name',
      title: '物料名称',
      dataIndex: 'name',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'manuCode',
      title: '规格型号',
      dataIndex: 'manuCode',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'unitName',
      title: '单位',
      dataIndex: 'unitName',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        filterDescription(text, record, index),
    },
    {
      key: 'sellArea',
      title: '库存所在地',
      dataIndex: 'sellArea',
      render: (text: string, record: ProductSellAreaDTO, index: number) =>
        sellAreaRender(text, record, index),
    },
    {
      key: 'stock',
      title: '区域库存',
      dataIndex: 'stock',
      render: (text: number, record: ProductSellAreaDTO, index: number) =>
        stockRender(text, record, index),
    },
    {
      key: 'state',
      title: '库存状态',
      dataIndex: 'state',
      render: (text: number, record: ProductSellAreaDTO, index: number) =>
        switchRender(record, index),
    },
    {
      key: 'operate',
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: ProductSellAreaDTO, index: number) => {
        return index === 0 ||
          dataSource.data[index - 1].code !== record.code ? (
          <a onClick={() => openReviseModal(record)}>编辑</a>
        ) : (
          ''
        )
      },
    },
  ]

  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['productCode', 'proName', 'model']}
        onSearch={handleSearchClick}
        keyName="INVENTORYMANAGEMENT"
        ScreenKey="INVENTORYMANAGEMENT"
      />
      <Row
        justify="space-between"
        align="middle"
        className={styles['info-row']}
      >
        <Space>
          <Buttonbar onRefresh={onRefresh}></Buttonbar>
          <Form
            form={platform}
            style={{ marginLeft: '-120px', height: '24px', lineHeight: '24px' }}
          >
            <Form.Item label="当前项目：" name={'project'}>
              <Select
                style={{ width: 150 }}
                options={projectOptions}
                onChange={() => handleSearchClick({})}
              />
            </Form.Item>
          </Form>
        </Space>
        <Space>
          <Tooltip
            title={
              <>
                <div>
                  1.
                  如果物料只存在指定区域售卖，在设置区域库存的同时，全国仓库存必须设为：0（即：关闭全国仓库存），全国仓地址编码为：-9999；
                </div>
                <div>2. 区域库存和全国仓库存必须分两行导入；</div>
                <div>
                  3.
                  区域库存和全国库存也可同时存在，可按需设置，如：北京设：10；全国设：200
                </div>
              </>
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>

          <span>库存管理规则</span>
          <Button onClick={exportData}>导出全部</Button>
          <Button type="primary" onClick={() => changeImportModalVisible(true)}>
            导入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
      {/* 修改库存弹框 */}
      <Modal
        title="修改库存"
        open={isReviseModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={600}
        style={{ top: '25%' }}
        footer={[
          <Button
            key="closeRejectModal"
            disabled={reviseModalConfirmBtnLoading}
            onClick={closeReviseModal}
          >
            取消
          </Button>,
          <Button
            key="confirmRejectModal"
            type="primary"
            loading={reviseModalConfirmBtnLoading}
            onClick={cofirmReviseInventory}
          >
            提交
          </Button>,
        ]}
      >
        <Spin tip="Loading..." spinning={editLoading}>
          <div>
            <div
              style={{
                marginTop: '-12px',
                marginBottom: '12px',
              }}
            >
              <Row>
                <Col span={12}>物料编码：{currentReviseMaterial.code}</Col>
                <Col span={12}>物料名称：{currentReviseMaterial.name}</Col>
              </Row>
              <Row>
                <Col span={12}>规格型号：{currentReviseMaterial.manuCode}</Col>
                <Col span={12}>单位：{currentReviseMaterial.unitName}</Col>
              </Row>
            </div>
            <div
              style={{
                overflow: 'auto',
                minHeight: '400px',
                maxHeight: '550px',
              }}
            >
              <Form form={form}>
                <Form.List name="list">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space
                          key={key}
                          style={{ display: 'flex' }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            label="可售区域"
                            name={[name, 'sellArea']}
                            rules={[
                              { required: true, message: '请选择可售区域' },
                            ]}
                          >
                            <TreeSelect
                              showSearch
                              treeNodeFilterProp="title"
                              dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                              }}
                              placeholder="请选择"
                              allowClear
                              multiple
                              treeDefaultExpandAll
                              treeData={areaDataOptions}
                              style={{ width: '200px' }}
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label="区域库存"
                            name={[name, 'stock']}
                            rules={[
                              { required: true, message: '请输入区域库存' },
                            ]}
                          >
                            <InputNumber
                              precision={0}
                              min={-99999}
                              max={999999999}
                              style={{ width: '120px' }}
                            />
                          </Form.Item>
                          <Form.Item {...restField} name={[name, 'isNewItem']}>
                            {!form.getFieldsValue().list[index]?.isNewItem ? (
                              <MinusCircleOutlined
                                style={{ margin: '0 12px' }}
                                onClick={() => remove(name)}
                              />
                            ) : (
                              ''
                            )}
                          </Form.Item>
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusCircleOutlined />}
                        >
                          添加库存所在地及库存
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
      {/* 导入区域库存弹框 */}
      <Modal
        title="导入区域库存"
        open={isImportModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={'30%'}
        style={{ top: '25%' }}
        okText="提交"
        cancelButtonProps={{
          disabled: isImportModalConfirmBtnLoading,
          onClick: () => changeImportModalVisible(false),
        }}
        okButtonProps={{
          type: 'primary',
          loading: isImportModalConfirmBtnLoading,
          onClick: cofirmImportModal,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={downloadTemplate}>
            下载导入模板 <DownloadOutlined />
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title="选择文件"
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            getOriginFile={getOriginFile}
            accept=".xls,.xlsx"
            maxCount={1}
            directlyDelete
            type = "regionalStock"
          />
          {!uploadFilesList.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default InventoryManagement
